import type { DocPageContent } from '../docs-content'

const page = {
  order: 21,
  slug: 'settings',
  title: '设置',
  description:
    '通用、时间轴、AI 与存储标签页，以及语言和快捷键在哪里设置。',
  category: '参考',
  related: ['keyboard-shortcuts', 'workspaces'],
  sections: [
    {
      title: '四个标签页',
      blocks: [
        {
          kind: 'table',
          headers: ['标签页', '可设置的内容'],
          rows: [
            [
              '通用',
              '自动保存的开关与间隔（5–30 分钟）；撤销历史深度（10–200 步）；界面音效（开关、音量、音效主题）。',
            ],
            [
              '时间轴',
              '默认吸附；显示波形与胶片条；导入时提取胶片条。',
            ],
            ['AI', '字幕采样间隔（秒或帧）；默认字幕样式。'],
            [
              '存储',
              '生成缺失的代理；清除项目缓存；重新生成缩略图；删除代理；管理本地 AI。',
            ],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '清除项目缓存会移除重新生成的数据（波形、胶片条、GIF 帧、解码后的音频）；它永远不会删除源媒体。使用对话框标题栏中的**重置**可恢复默认值。',
        },
      ],
    },
    {
      title: '界面音效',
      blocks: [
        {
          kind: 'paragraph',
          text: '精剪可以播放微妙的合成界面音效——用于确认选择、确认、切换和删除等操作的简短提示音。它们**默认关闭**，采用 opt-in 方式，且永远不会影响导出的音频。',
        },
        {
          kind: 'steps',
          items: [
            '打开**设置**并进入**通用**标签页。',
            '开启**界面音效**。',
            '按需设置**音效音量**（0–100%）。',
            '选择一个**音效主题**——**特色**、**丝绒**或**清脆**——并使用**预览**按钮试听。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '预览播放时音效会被抑制，因此它们永远不会串入你正在监听的音频；导出在设计中本就是静音的。开启开关时也会播放一段简短的确认音。',
        },
      ],
    },
    {
      title: '自定义键盘快捷键',
      blocks: [
        {
          kind: 'paragraph',
          text: '键盘快捷键可完全自定义，但编辑器是它自己的对话框，从工具栏中的**键盘**按钮打开——而不是本设置对话框。它具备交互式屏幕键盘、搜索以及**自定义** / **冲突** / **未分配**筛选、录制重绑定、备用绑定、逐命令与**全部重置**默认值、冲突检测，以及 JSON 预设的**导入** / **导出**。',
        },
        {
          kind: 'note',
          tone: 'tip',
          text: '请参阅**键盘快捷键**页面查看完整的命令列表与分步重绑定说明。',
        },
      ],
    },
    {
      title: '在其他地方设置',
      blocks: [
        {
          kind: 'list',
          items: [
            '界面**语言**是工具栏中的一个独立控件，不属于本对话框；精剪提供 9 种语言。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '精剪目前使用单一深色主题；没有主题选择器。',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
